import React, { useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ServiceRequests } from '../Maintenance/ServiceRequests'
import { useServiceRequest } from '../../hooks/useServiceRequest'
import { activeStatuses, ServiceRequest } from '../../types/serviceRequest'
import { MessageModal } from '../Message/MessageModal'

export const MaintenanceSummary = () => {
    const theme = useTheme()
    const navigate = useNavigate()

    const [selectedServiceRequestChannel, setSelectedServiceRequestChannel] =
        useState<number>(-1)
    const [disableMessaging, setDisableMessaging] = useState(false)

    // Integrate useServiceRequest hook
    const {
        isLoading,
        serviceRequestList,
        getServiceRequestList,
        getServiceRequestChannel,
        updateServiceRequestState,
    } = useServiceRequest()

    useEffect(() => {
        getServiceRequestList()
    }, [])

    const onClickServiceRequestChannel = (serviceRequest: ServiceRequest) => {
        if (serviceRequest.channel_id) {
            setSelectedServiceRequestChannel(serviceRequest.channel_id)
        } else {
            getServiceRequestChannel(serviceRequest).then((channel) => {
                setSelectedServiceRequestChannel(channel)
            })
        }
        if (
            serviceRequest.workorder?.status &&
            !activeStatuses.includes(serviceRequest.workorder.status)
        ) {
            setDisableMessaging(true)
        } else {
            setDisableMessaging(false)
        }
    }

    return (
        <Box
            sx={{
                backgroundColor: '#2a2f35',
                borderRadius: 2,
                padding: 3,
                marginBottom: 3,
            }}
        >
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                }}
            >
                <Typography
                    variant="h6"
                    style={{
                        color: '#fff',
                        marginBottom: theme.spacing(2),
                    }}
                >
                    Maintenance
                </Typography>
                <ServiceRequests
                    serviceRequestList={serviceRequestList}
                    onClickChannel={onClickServiceRequestChannel}
                />
            </Box>
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flex: 1,
                    marginTop: theme.spacing(2),
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => {
                        navigate('/maintenance?tab=submit')
                    }}
                    sx={{
                        bgcolor: theme.palette.primary.main,
                        color: 'white',
                        borderRadius: '12px',
                        px: 4,
                        '&:hover': {
                            bgcolor: theme.palette.primary.dark,
                        },
                        width: '100%',
                    }}
                >
                    Submit Request
                </Button>
            </Box>
            <MessageModal
                open={selectedServiceRequestChannel !== -1}
                channelId={selectedServiceRequestChannel}
                onClose={() => setSelectedServiceRequestChannel(-1)}
                afterCreateMessage={() => {
                    const serviceRequest = serviceRequestList.find(
                        (serviceRequest) =>
                            serviceRequest.channel_id ===
                            selectedServiceRequestChannel,
                    )
                    if (serviceRequest) {
                        updateServiceRequestState({
                            ...serviceRequest,
                            message_count:
                                (serviceRequest.message_count ?? 0) + 1,
                            unread_count: 0,
                        })
                    }
                }}
                disableMessaging={disableMessaging}
            />
        </Box>
    )
}
